import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./styles";

const OneParkAccountTable = ({ rows, order, orderBy, onSort, onRowClick }) => {
  const classes = useStyles();

  const columns = [
    { key: "email", label: "Emails" },
    { key: "points", label: "Points" },
    { key: "signupDate", label: "Signup Date" },
    { key: "lastUse", label: "Last Use" },
    { key: "accountBalance", label: "Account Balance" },
    { key: "status", label: "Status" },
  ];

  return (
    <Table className={clsx(classes.table, "onepark-account-table")}>
        <TableHead>
          <TableRow className={clsx(classes.headerRow, "onepark-account-header-row")}>
            {columns.map((col) => (
              <TableCell key={col.key} className={clsx(classes.headerCell, `onepark-account-header-${col.key}`)}>
                <TableSortLabel
                  active={orderBy === col.key}
                  direction={orderBy === col.key ? order : "asc"}
                  onClick={() => onSort(col.key)}
                >
                  {col.label}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow 
              key={row.id} 
              className={clsx(classes.bodyRow, classes.clickableRow, `onepark-account-row-${row.id}`)}
              onClick={() => onRowClick && onRowClick(row)}
            >
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-email")}>{row.email || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-points")}>{row.points || "-"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-signupDate")}>{row.signupDate || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-lastUse")}>{row.lastUse || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-accountBalance")}>{row.accountBalance || "-"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-status")}>{row.status || "–"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
    </Table>
  );
};

export default OneParkAccountTable;